/*! HarAndaz Maison — cod.js v1.0.0 | One-step Cash-on-Delivery order form (talks to the HarAndaz COD Engine) */
(() => {
  'use strict';

  const HA = (window.HA = window.HA || {});
  const d = document;
  const $ = (s, r = d) => r.querySelector(s);
  const $$ = (s, r = d) => Array.from(r.querySelectorAll(s));
  const S = () => HA.settings || {};
  const T = () => HA.strings || {};
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fm = (c) => (HA.formatMoney ? HA.formatMoney(c) : 'Rs.' + Math.round((Number(c) || 0) / 100).toLocaleString('en-US'));
  const icon = (n) => (HA.icons && HA.icons[n]) || '';
  const publish = (n, data) => { try { if (HA.publish) HA.publish(n, data); } catch (e) { /* noop */ } };
  const lsGet = (k) => { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } };
  const lsSet = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } };
  const num = (v) => (v === null || v === undefined || v === '' ? NaN : Number(v));
  const uid = () => {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) { /* noop */ }
    return 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  };

  const MAX_QTY = 10;
  const CFG_KEY = 'ha_cod_cfg';
  const CUST_KEY = 'ha_cod_customer';
  const CHECK_SVG = '<svg width="34" height="34" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  const WA_SVG = '<svg class="icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.08-.3-.15-1.26-.47-2.39-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.18-1.42-.08-.12-.28-.2-.57-.34zM12.05 21.8h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.88 9.88zm8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89 0-3.18-1.24-6.16-3.48-8.41z"/></svg>';
  const GIFT_SVG = '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7S10.5 3 8 3.6C6 4.1 6.6 7 9 7M12 7s1.5-4 4-3.4C18 4.1 17.4 7 15 7"/></svg>';

  /* ---------- Unicode helpers (old Safari safe) ---------- */
  let LETTER;
  try { LETTER = new RegExp('\\p{L}', 'u'); } catch (e) { LETTER = /[A-Za-z\u00C0-\u024F\u0600-\u06FF]/; }
  const asciiDigits = (s) => String(s || '')
    .replace(/[\u0660-\u0669]/g, (c) => String(c.charCodeAt(0) - 0x0660))
    .replace(/[\u06F0-\u06F9]/g, (c) => String(c.charCodeAt(0) - 0x06F0));

  /* ---------- Pakistani mobile number → 03XXXXXXXXX ---------- */
  const normPhone = (raw) => {
    let p = asciiDigits(raw).replace(/\D/g, '');
    if (p.startsWith('0092')) p = p.slice(4);
    else if (p.startsWith('92') && p.length === 12) p = p.slice(2);
    if (p.length === 10 && p.charAt(0) === '3') p = '0' + p;
    return p;
  };
  const phoneOk = (p) => /^03\d{9}$/.test(p);

  const timedFetch = (url, opts = {}, ms = 15000) => {
    const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    const t = setTimeout(() => { if (ctrl) ctrl.abort(); }, ms);
    return fetch(url, Object.assign({}, opts, ctrl ? { signal: ctrl.signal } : {})).finally(() => clearTimeout(t));
  };

  /* ---------- Pricing config (engine is the source of truth, theme settings are the fallback) ---------- */
  const cleanOffers = (list) => (Array.isArray(list) ? list : [])
    .map((o) => ({
      qty: Math.round(num(o && o.qty) || 0),
      pct: Math.min(90, Math.max(0, num(o && o.pct) || 0)),
      code: String((o && o.code) || '').trim(),
      badge: String((o && o.badge) || '').trim()
    }))
    .filter((o) => o.qty > 1 && o.pct > 0)
    .sort((a, b) => a.qty - b.qty);

  const baseCfg = () => {
    const s = S();
    return {
      currency: HA.currency || 'PKR',
      shippingFee: Math.max(0, num(s.shipFee) || 0),
      freeShippingMin: Math.max(0, num(s.freeShip) || 0),
      offers: cleanOffers(s.offers)
    };
  };

  const mergeCfg = (c) => {
    const base = baseCfg();
    const out = Object.assign({}, base);
    if (!c || typeof c !== 'object') return out;
    if (Number.isFinite(num(c.shippingFee))) out.shippingFee = Math.max(0, num(c.shippingFee));
    if (Number.isFinite(num(c.freeShippingMin))) out.freeShippingMin = Math.max(0, num(c.freeShippingMin));
    if (Array.isArray(c.offers)) {
      out.offers = cleanOffers(c.offers).map((o) => {
        if (!o.badge) { const t = base.offers.find((b) => b.qty === o.qty); if (t) o.badge = t.badge; }
        return o;
      });
    }
    if (c.currency) out.currency = String(c.currency);
    return out;
  };

  let cfgPromise = null;
  let lastCfg = null;
  const loadCfg = () => {
    const engine = S().engine;
    if (!engine) return Promise.resolve(baseCfg());
    if (cfgPromise) return cfgPromise;
    cfgPromise = (async () => {
      try {
        const c = JSON.parse(sessionStorage.getItem(CFG_KEY) || 'null');
        if (c && c.e === engine && Date.now() - c.t < 6e5) return (lastCfg = mergeCfg(c.c));
      } catch (e) { /* noop */ }
      try {
        const res = await timedFetch(engine + '/config', { mode: 'cors', credentials: 'omit' }, 4000);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const c = await res.json();
        try { sessionStorage.setItem(CFG_KEY, JSON.stringify({ e: engine, t: Date.now(), c })); } catch (e) { /* noop */ }
        return (lastCfg = mergeCfg(c));
      } catch (e) {
        setTimeout(() => { cfgPromise = null; }, 0);
        return baseCfg();
      }
    })();
    return cfgPromise;
  };

  /* ---------- State ---------- */
  const st = { items: [], cfg: baseCfg(), source: 'product', code: '', key: '', busy: false, complete: false, opened: 0 };

  const toItem = (i) => {
    if (!i) return null;
    const variantId = Number(i.variantId || i.variant_id || i.id);
    if (!variantId) return null;
    const tags = Array.isArray(i.tags) ? i.tags.map((t) => String(t).toLowerCase()) : [];
    return {
      variantId,
      quantity: Math.min(MAX_QTY, Math.max(1, Math.round(Number(i.quantity) || 1))),
      title: String(i.title || ''),
      variantTitle: i.variantTitle && i.variantTitle !== 'Default Title' ? String(i.variantTitle) : '',
      price: Math.max(0, Math.round(Number(i.price) || 0)),
      compare: Math.max(0, Math.round(Number(i.compare) || 0)),
      image: i.image || '',
      productId: i.productId || i.product_id || '',
      handle: i.handle || '',
      url: i.url || '',
      noOffers: !!i.noOffers || tags.includes('no-offers'),
      properties: i.properties && typeof i.properties === 'object' && Object.keys(i.properties).length ? i.properties : null
    };
  };

  const totals = () => {
    const cfg = st.cfg;
    let sub = 0; let eSub = 0; let eQty = 0; let qty = 0;
    st.items.forEach((i) => {
      const line = i.price * i.quantity;
      sub += line; qty += i.quantity;
      if (!i.noOffers) { eSub += line; eQty += i.quantity; }
    });
    let tier = null;
    let next = null;
    cfg.offers.forEach((o) => {
      if (eQty >= o.qty && (!tier || o.qty > tier.qty)) tier = o;
      if (o.qty > eQty && (!next || o.qty < next.qty)) next = o;
    });
    // Discount is rounded down to a whole rupee — the engine uses the exact same formula.
    const disc = tier ? Math.floor((eSub * tier.pct) / 10000) * 100 : 0;
    const after = sub - disc;
    const ship = !qty ? 0 : (cfg.freeShippingMin > 0 && after >= cfg.freeShippingMin ? 0 : cfg.shippingFee);
    return { sub, disc, tier, ship, total: after + ship, qty, eQty, next };
  };

  const imgUrl = (u, w) => {
    if (!u) return '';
    let s = String(u);
    if (s.startsWith('//')) s = 'https:' + s;
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(s)) return s;
    try { const url = new URL(s, location.origin); url.searchParams.set('width', w); return url.toString(); } catch (e) { return s; }
  };

  /* ---------- DOM refs ---------- */
  let drawer; let form; let doneEl; let itemsEl; let errEl; let submitBtn;
  const bindRefs = () => {
    drawer = d.getElementById('CodDrawer');
    if (!drawer) return false;
    form = $('[data-cod-form]', drawer);
    doneEl = $('[data-cod-done]', drawer);
    itemsEl = $('[data-cod-items]', drawer);
    errEl = $('[data-cod-error]', drawer);
    submitBtn = $('[data-cod-submit]', drawer);
    return !!(form && itemsEl);
  };

  /* ---------- Rendering ---------- */
  const itemHTML = (i, idx) => {
    const t = T();
    const img = i.image ? `<img src="${esc(imgUrl(i.image, 160))}" alt="" width="64" height="80" loading="lazy" decoding="async">` : '';
    const canRemove = st.items.length > 1;
    return `<div class="cod-item" data-cod-i="${idx}">
      <div class="cod-item__media media" style="--ratio: .8">${img}</div>
      <div class="cod-item__info">
        <p class="cod-item__title">${esc(i.title)}</p>
        ${i.variantTitle ? `<p class="cod-item__variant">${esc(i.variantTitle)}</p>` : ''}
        <div class="cod-item__row">
          <div class="qty qty--sm">
            <button type="button" data-cod-step="-1" aria-label="${esc(t.decrease || 'Decrease')}"${i.quantity <= 1 ? ' disabled' : ''}>${icon('minus')}</button>
            <input type="number" inputmode="numeric" min="1" max="${MAX_QTY}" value="${i.quantity}" data-cod-qty aria-label="${esc(t.quantity || 'Quantity')}">
            <button type="button" data-cod-step="1" aria-label="${esc(t.increase || 'Increase')}"${i.quantity >= MAX_QTY ? ' disabled' : ''}>${icon('plus')}</button>
          </div>
          <p class="cod-item__price" data-cod-price>${priceHTML(i)}</p>
        </div>
      </div>
      ${canRemove ? `<button type="button" class="cod-item__remove" data-cod-remove aria-label="${esc((t.remove || 'Remove') + ': ' + i.title)}">${icon('close')}</button>` : ''}
    </div>`;
  };
  const priceHTML = (i) => (i.compare > i.price ? `<s>${fm(i.compare * i.quantity)}</s>` : '') + fm(i.price * i.quantity);

  const extraHTML = () => {
    const t = T();
    const tt = totals();
    const cfg = st.cfg;
    const single = st.items.length === 1 ? st.items[0] : null;
    if (single && !single.noOffers && cfg.offers.length) {
      const tiers = [{ qty: 1, pct: 0, badge: '' }].concat(cfg.offers.slice(0, 3));
      const last = tiers[tiers.length - 1];
      let active = tiers.find((o) => o.qty === single.quantity);
      if (!active && single.quantity > last.qty) active = last;
      const chips = tiers.map((o) => {
        const gross = single.price * o.qty;
        const fin = gross - (o.pct ? Math.floor((gross * o.pct) / 10000) * 100 : 0);
        const on = active === o;
        return `<button type="button" class="cod-offer${on ? ' is-active' : ''}" data-cod-offer="${o.qty}" aria-pressed="${on}">
          ${o.badge ? `<i class="cod-offer__badge">${esc(o.badge)}</i>` : ''}
          <b>${esc((t.buyN || 'Buy 99').replace('99', o.qty))}</b>
          <span>${fm(fin)}</span>
          ${o.pct ? `<span class="cod-offer__save">${esc(t.save || 'Save')} ${o.pct}%</span>` : ''}
        </button>`;
      }).join('');
      return `<div class="cod-offers" role="group" aria-label="${esc(t.quantity || 'Quantity')}">${chips}</div>`;
    }
    if (tt.next && tt.eQty > 0) {
      const more = tt.next.qty - tt.eQty;
      const txt = (t.offerNext || 'Add %c more & get %p% off').replace('%c', more).replace('%p', tt.next.pct);
      return `<p class="cod__hint">${GIFT_SVG}<span>${esc(txt)}</span></p>`;
    }
    return '';
  };

  const renderItems = () => {
    if (!itemsEl) return;
    itemsEl.innerHTML = st.items.map(itemHTML).join('') + `<div class="cod__extra" data-cod-extra>${extraHTML()}</div>`;
  };

  const renderExtra = () => {
    const x = $('[data-cod-extra]', itemsEl);
    if (!x) return;
    const focused = d.activeElement && d.activeElement.closest && d.activeElement.closest('[data-cod-offer]');
    const fq = focused ? focused.dataset.codOffer : null;
    x.innerHTML = extraHTML();
    if (fq) { const b = $(`[data-cod-offer="${fq}"]`, x); if (b) b.focus({ preventScroll: true }); }
  };

  const setText = (sel, txt) => { const el = $(sel, drawer); if (el) el.textContent = txt; return el; };

  const paint = () => {
    if (!drawer) return;
    const t = T();
    const tt = totals();
    setText('[data-sum-sub]', fm(tt.sub));
    const row = $('[data-sum-disc-row]', drawer);
    if (row) row.hidden = !tt.disc;
    if (tt.disc && tt.tier) {
      setText('[data-sum-disc-label]', (t.offerSave || '%p% bundle discount').replace('%p', tt.tier.pct));
      setText('[data-sum-disc]', '−' + fm(tt.disc));
    }
    const ship = setText('[data-sum-ship]', tt.ship ? fm(tt.ship) : (t.free || 'Free'));
    if (ship) ship.classList.toggle('is-free', !tt.ship);
    setText('[data-sum-total]', fm(tt.total));
    setText('[data-sum-total-btn]', fm(tt.total));
  };

  const setQty = (idx, q) => {
    const it = st.items[idx];
    if (!it) return;
    const n = Math.min(MAX_QTY, Math.max(1, Math.round(Number(q) || 1)));
    it.quantity = n;
    const row = $(`[data-cod-i="${idx}"]`, itemsEl);
    if (row) {
      const inp = $('[data-cod-qty]', row);
      if (inp && Number(inp.value) !== n) inp.value = n;
      const [minus, plus] = $$('[data-cod-step]', row);
      if (minus) minus.disabled = n <= 1;
      if (plus) plus.disabled = n >= MAX_QTY;
      const pr = $('[data-cod-price]', row);
      if (pr) pr.innerHTML = priceHTML(it);
    }
    renderExtra();
    paint();
  };

  const removeItem = (idx) => {
    if (st.items.length <= 1) return;
    st.items.splice(idx, 1);
    renderItems();
    paint();
    const first = $('[data-cod-qty]', itemsEl);
    if (first) first.focus({ preventScroll: true });
  };

  /* ---------- Form fields & validation ---------- */
  const fieldEl = (name) => $(`[data-field="${name}"]`, form);
  const fld = (name) => (form && form.elements.namedItem ? form.elements.namedItem(name) : null);
  const val = (name) => { const el = fld(name); return el && 'value' in el ? String(el.value || '').trim() : ''; };

  const rules = {
    name: (v) => (v.length >= 3 && LETTER.test(v) && !/\d{3,}/.test(v)) || 'errName',
    phone: (v) => phoneOk(normPhone(v)) || 'errPhone',
    city: (v) => (v.length >= 2 && LETTER.test(v)) || 'errCity',
    address: (v) => v.replace(/\s+/g, ' ').length >= 10 || 'errAddress',
    email: (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) || 'errEmail'
  };

  const setErr = (name, msg) => {
    const f = fieldEl(name);
    if (!f) return;
    const e = $('[data-err]', f);
    const inp = $('input, textarea', f);
    f.classList.toggle('is-invalid', !!msg);
    if (e) { e.id = e.id || 'CodErr-' + name; e.textContent = msg || ''; }
    if (inp) {
      inp.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (msg && e) inp.setAttribute('aria-describedby', e.id); else inp.removeAttribute('aria-describedby');
    }
  };

  const check = (name) => {
    if (!fieldEl(name)) return true;
    const r = rules[name](val(name));
    if (r === true) { setErr(name, ''); return true; }
    setErr(name, T()[r] || 'Please check this field.');
    return false;
  };

  const validateAll = () => {
    let first = null;
    ['name', 'phone', 'city', 'address', 'email'].forEach((n) => {
      if (!check(n) && !first) first = n;
    });
    if (first) {
      const inp = $('input, textarea', fieldEl(first));
      if (inp) {
        inp.focus({ preventScroll: true });
        try { inp.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { inp.scrollIntoView(); }
      }
      return false;
    }
    return true;
  };

  const prefill = () => {
    const c = lsGet(CUST_KEY);
    if (!c || !form) return;
    ['name', 'phone', 'city', 'address', 'email'].forEach((n) => {
      const el = fld(n);
      if (el && !el.value && c[n]) el.value = c[n];
    });
  };

  const showError = (msg, withFallback) => {
    if (!errEl) return;
    const t = T();
    let h = esc(msg || t.errGeneric || 'We could not place your order right now.');
    if (withFallback) h += ` <a href="${esc(fallbackUrl())}">${esc(t.fallback || 'Continue to secure checkout')} &rarr;</a>`;
    errEl.innerHTML = h;
    errEl.hidden = false;
    try { errEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { /* noop */ }
  };
  const hideError = () => { if (errEl) { errEl.hidden = true; errEl.innerHTML = ''; } };

  const fallbackUrl = () => {
    const tt = totals();
    const code = tt.tier ? tt.tier.code : st.code;
    if (HA.checkoutUrl) return HA.checkoutUrl(st.items.map((i) => ({ id: i.variantId, quantity: i.quantity })), code);
    return (HA.routes && HA.routes.root ? HA.routes.root.replace(/\/$/, '') : '') + '/cart/' + st.items.map((i) => `${i.variantId}:${i.quantity}`).join(',') + (code ? '?discount=' + encodeURIComponent(code) : '');
  };

  const setBusy = (on) => {
    st.busy = on;
    if (!submitBtn) return;
    submitBtn.classList.toggle('is-loading', on);
    submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    const lbl = $('.btn__label', submitBtn);
    if (on) submitBtn.setAttribute('aria-label', T().placing || 'Placing your order…'); else submitBtn.removeAttribute('aria-label');
    if (lbl) lbl.setAttribute('aria-hidden', on ? 'true' : 'false');
  };

  /* ---------- Analytics helpers ---------- */
  const sha256 = async (s) => {
    if (!s || !window.crypto || !crypto.subtle || typeof TextEncoder !== 'function') return '';
    try {
      const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(s));
      return Array.from(new Uint8Array(buf)).map((x) => x.toString(16).padStart(2, '0')).join('');
    } catch (e) { return ''; }
  };
  const hashedUser = async (c) => {
    const parts = c.name.toLowerCase().split(/\s+/).filter(Boolean);
    const [ph, fn, ln, ct, country, em, ph164] = await Promise.all([
      sha256('92' + c.phone.slice(1)),
      sha256(parts[0] || ''),
      sha256(parts.slice(1).join(' ')),
      sha256(c.city.toLowerCase().replace(/[^a-z\u0600-\u06ff]/g, '')),
      sha256('pk'),
      sha256((c.email || '').toLowerCase()),
      sha256('+92' + c.phone.slice(1))
    ]);
    // ph = Meta format (digits only), ph_e164 = TikTok format (+92…). Both SHA-256.
    const out = { ph, fn, country, external_id: ph, ph_e164: ph164 };
    if (ln) out.ln = ln;
    if (ct) out.ct = ct;
    if (em) out.em = em;
    return out;
  };
  const eventItems = () => st.items.map((i) => ({
    variant_id: String(i.variantId), product_id: String(i.productId || ''), title: i.title, variant_title: i.variantTitle,
    quantity: i.quantity, price: i.price / 100
  }));

  /* ---------- Success screen ---------- */
  const showDone = (res, c, tt) => {
    const s = S();
    const t = T();
    const total = Number.isFinite(num(res.total)) ? Math.round(num(res.total)) : tt.total;
    const orderName = String(res.orderName || '');
    const wa = String(s.wa || '').replace(/\D/g, '');
    let waHref = '';
    if (wa) {
      const msg = (t.waConfirm || 'Hi! I placed order %o (%t, Cash on Delivery). Name: %n, City: %c. Please confirm.')
        .replace('%o', orderName).replace('%t', fm(total)).replace('%n', c.name).replace('%c', c.city);
      waHref = `https://wa.me/${wa}?text=${encodeURIComponent(msg)}`;
    }
    const steps = [t.next1, t.next2, t.next3].filter(Boolean).map((x) => `<li>${esc(x)}</li>`).join('');
    doneEl.innerHTML = `
      <div class="cod-done__check">${CHECK_SVG}</div>
      <h2 class="cod-done__title">${esc(s.tyTitle || 'Shukriya!')}</h2>
      ${s.tyText ? `<p class="cod-done__text">${esc(s.tyText)}</p>` : ''}
      ${orderName ? `<p class="cod-done__num">${esc((t.orderNumber || 'Order %n').replace('%n', orderName))}</p>` : ''}
      <p class="cod-done__total">${esc(t.codTotal || 'Total')}: <b>${fm(total)}</b></p>
      ${steps ? `<p class="eyebrow cod-done__label">${esc(t.nextTitle || '')}</p><ol class="cod-done__steps">${steps}</ol>` : ''}
      <div class="cod-done__actions">
        ${waHref ? `<a class="btn btn--wa btn--block btn--lg" href="${esc(waHref)}" target="_blank" rel="noopener">${WA_SVG}<span class="btn__label">${esc(s.tyWa || 'Confirm on WhatsApp')}</span></a>` : ''}
        <button type="button" class="btn btn--outline btn--block" data-close><span class="btn__label">${esc(t.continueShopping || 'Continue shopping')}</span></button>
      </div>`;
    form.hidden = true;
    doneEl.hidden = false;
    try { doneEl.focus({ preventScroll: true }); } catch (e) { doneEl.focus(); }
    const panel = doneEl.closest('.drawer__panel');
    if (panel) panel.scrollTop = 0;
    return total;
  };

  const resetView = () => {
    st.complete = false;
    if (doneEl) { doneEl.hidden = true; doneEl.innerHTML = ''; }
    if (form) {
      form.hidden = false;
      ['note', 'website'].forEach((n) => { const el = fld(n); if (el) el.value = ''; });
    }
    hideError();
  };

  /* ---------- Submit ---------- */
  const submit = async (e) => {
    e.preventDefault();
    if (st.busy || !st.items.length) return;
    hideError();
    if (!validateAll()) return;
    const engine = S().engine;
    if (!engine) { location.href = fallbackUrl(); return; }

    const c = {
      name: val('name').replace(/\s+/g, ' '),
      phone: normPhone(val('phone')),
      city: val('city').replace(/\s+/g, ' '),
      address: val('address').replace(/\s+/g, ' '),
      email: val('email').toLowerCase(),
      note: val('note')
    };
    const tt = totals();
    const src = (HA.getSource && HA.getSource()) || {};
    const ck = (n) => (HA.cookie ? HA.cookie(n) : '');
    let fbc = ck('_fbc');
    if (!fbc && src.fbclid) fbc = `fb.1.${Date.now()}.${src.fbclid}`;
    const payload = {
      key: st.key,
      items: st.items.map((i) => {
        const o = { variantId: i.variantId, quantity: i.quantity };
        if (i.properties) o.properties = i.properties;
        return o;
      }),
      customer: c,
      offerCode: tt.tier ? tt.tier.code : '',
      clientTotal: tt.total,
      currency: st.cfg.currency,
      attribution: src,
      fbp: ck('_fbp'),
      fbc,
      ttp: ck('_ttp'),
      source: st.source,
      page: location.href.slice(0, 300),
      website: val('website')
    };

    setBusy(true);
    let res = null;
    let status = 0;
    try {
      const r = await timedFetch(engine + '/order', {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload)
      }, 20000);
      status = r.status;
      try { res = await r.json(); } catch (x) { res = null; }
      if (!r.ok || !res || !res.ok) {
        const err = new Error((res && res.message) || '');
        err.field = res && res.field;
        err.server = !!res;
        throw err;
      }
    } catch (err) {
      setBusy(false);
      const field = err && err.field;
      if (field && fieldEl(field)) {
        setErr(field, err.message || T()['err' + field.charAt(0).toUpperCase() + field.slice(1)] || T().errGeneric);
        const inp = $('input, textarea', fieldEl(field));
        if (inp) inp.focus();
      } else {
        showError(err && err.server ? err.message : '', true);
      }
      publish('cod_order_error', { message: String((err && err.message) || (err && err.name) || 'error').slice(0, 120), status, source: st.source });
      return;
    }

    setBusy(false);
    lsSet(CUST_KEY, { name: c.name, phone: c.phone, city: c.city, address: c.address, email: c.email });
    st.complete = true;
    const total = showDone(res, c, tt);
    const eventId = String(res.eventId || 'cod_' + st.key);
    const items = eventItems();
    const currency = st.cfg.currency || HA.currency || 'PKR';
    const data = {
      event_id: eventId,
      order_id: String(res.orderId || ''),
      order_name: String(res.orderName || ''),
      value: total / 100,
      currency,
      num_items: tt.qty,
      offer_code: payload.offerCode,
      source: st.source,
      items,
      content_ids: items.map((i) => i.variant_id),
      user: await hashedUser(c)
    };
    publish('cod_order', data);
    try {
      if (typeof window.fbq === 'function') window.fbq('track', 'Purchase', { value: data.value, currency, content_ids: data.content_ids, content_type: 'product', num_items: data.num_items }, { eventID: eventId });
      if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track('CompletePayment', { value: data.value, currency, contents: items.map((i) => ({ content_id: i.variant_id, quantity: i.quantity, price: i.price })), content_type: 'product' }, { event_id: eventId });
    } catch (x) { /* noop */ }
    if (st.source === 'cart' && HA.cart && HA.cart.clear) HA.cart.clear();
  };

  /* ---------- Open ---------- */
  const open = (opts = {}, opener) => {
    const items = (opts.items || []).map(toItem).filter(Boolean);
    if (!items.length) return;
    if (!bindRefs() || !S().engine) {
      const code = opts.code || '';
      if (HA.checkoutUrl) location.href = HA.checkoutUrl(items.map((i) => ({ id: i.variantId, quantity: i.quantity })), code);
      return;
    }
    resetView();
    st.items = items;
    st.code = opts.code || '';
    st.source = opts.source || 'product';
    st.key = uid();
    st.opened = Date.now();
    st.cfg = lastCfg || mergeCfg(null);
    renderItems();
    paint();
    prefill();
    if (drawer.open) drawer.open(opener); else drawer.hidden = false;
    loadCfg().then((cfg) => {
      if (!st.items.length || st.complete) return;
      st.cfg = cfg;
      renderExtra();
      paint();
    });
    const tt = totals();
    publish('cod_form_open', { source: st.source, value: tt.total / 100, currency: st.cfg.currency, num_items: tt.qty, items: eventItems(), content_ids: st.items.map((i) => String(i.variantId)) });
  };

  /* ---------- Cart → COD form ---------- */
  const openFromCart = async (btn) => {
    const s = S();
    const checkout = () => { location.href = (HA.routes && HA.routes.root ? HA.routes.root.replace(/\/$/, '') : '') + '/checkout'; };
    if (!s.engine) { checkout(); return; }
    btn.classList.add('is-loading');
    try {
      const [cart, cfg] = await Promise.all([
        HA.cart && HA.cart.get ? HA.cart.get() : fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()),
        loadCfg()
      ]);
      if (!cart || !cart.items || !cart.items.length) return;
      const ours = cfg.offers.map((o) => o.code.toUpperCase()).filter(Boolean);
      const titles = [];
      (cart.cart_level_discount_applications || []).forEach((a) => titles.push(a.title || a.key || 'x'));
      cart.items.forEach((i) => (i.line_level_discount_allocations || []).forEach((x) => titles.push((x.discount_application && (x.discount_application.title || x.discount_application.key)) || 'x')));
      const foreign = titles.filter((t) => !ours.includes(String(t).toUpperCase()));
      // Other discounts / gift cards / selling plans can only be honoured by Shopify checkout.
      if (foreign.length || (cart.total_discount > 0 && !titles.length) || cart.items.some((i) => i.selling_plan_allocation)) { checkout(); return; }
      const lines = {};
      $$('[data-line][data-key]').forEach((li) => { lines[li.dataset.key] = li; });
      const items = cart.items.map((i) => ({
        variantId: i.variant_id,
        quantity: i.quantity,
        title: i.product_title,
        variantTitle: i.product_has_only_default_variant ? '' : i.variant_title,
        price: i.original_price != null ? i.original_price : i.price,
        image: i.image || (i.featured_image && i.featured_image.url) || '',
        productId: i.product_id,
        handle: i.handle,
        url: i.url,
        noOffers: !!(lines[i.key] && lines[i.key].hasAttribute('data-no-offers')),
        properties: i.properties && Object.keys(i.properties).some((k) => i.properties[k] != null && i.properties[k] !== '') ? i.properties : null
      }));
      open({ items, source: 'cart' }, btn);
    } catch (e) {
      checkout();
    } finally {
      btn.classList.remove('is-loading');
    }
  };

  /* ---------- Bind ---------- */
  const bind = () => {
    if (!bindRefs()) return;
    if (drawer._codBound) return;
    drawer._codBound = true;

    drawer.addEventListener('click', (e) => {
      const step = e.target.closest('[data-cod-step]');
      if (step) {
        const row = step.closest('[data-cod-i]');
        const idx = Number(row && row.dataset.codI);
        if (st.items[idx]) setQty(idx, st.items[idx].quantity + Number(step.dataset.codStep));
        return;
      }
      const rm = e.target.closest('[data-cod-remove]');
      if (rm) { const row = rm.closest('[data-cod-i]'); removeItem(Number(row && row.dataset.codI)); return; }
      const of = e.target.closest('[data-cod-offer]');
      if (of) { e.preventDefault(); setQty(0, Number(of.dataset.codOffer)); }
    });

    drawer.addEventListener('change', (e) => {
      const q = e.target.closest('[data-cod-qty]');
      if (q) { const row = q.closest('[data-cod-i]'); setQty(Number(row && row.dataset.codI), q.value); }
    });

    form.addEventListener('input', (e) => {
      const el = e.target;
      if (el.name === 'phone' && /[\u0660-\u0669\u06F0-\u06F9]/.test(el.value)) el.value = asciiDigits(el.value);
      const f = el.closest('[data-field]');
      if (f && f.classList.contains('is-invalid')) check(f.dataset.field);
      if (errEl && !errEl.hidden) hideError();
    });

    form.addEventListener('focusout', (e) => {
      const el = e.target;
      const f = el.closest && el.closest('[data-field]');
      if (!f || !rules[f.dataset.field]) return;
      if (f.dataset.field === 'phone') { const p = normPhone(el.value); if (phoneOk(p)) el.value = p; }
      if (el.value.trim()) check(f.dataset.field);
    });

    form.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' || e.isComposing || e.target.tagName !== 'INPUT') return;
      if (e.target.matches('[data-cod-qty]')) { e.preventDefault(); e.target.blur(); return; }
      const fields = $$('.cod__fields input, .cod__fields textarea', form).filter((x) => x.name !== 'website' && x.offsetParent !== null);
      const i = fields.indexOf(e.target);
      const next = fields.slice(i + 1).find((x) => !x.value.trim() && x.required);
      if (next) { e.preventDefault(); next.focus(); }
    });

    form.addEventListener('submit', submit);

    drawer.addEventListener('drawer:close', () => {
      if (st.complete) setTimeout(() => { if (!drawer.classList.contains('is-open')) { resetView(); st.items = []; } }, 650);
    });
  };

  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cod-cart]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-loading')) return;
    openFromCart(b);
  });

  HA.cod = { open, normPhone, phoneOk, totals: () => totals(), loadConfig: loadCfg, version: '1.0.0' };

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', bind); else bind();
  d.addEventListener('shopify:section:load', bind);
  // Warm the pricing config in the background so the form opens instantly with server prices.
  if (S().engine && S().orderMode === 'instant') {
    const warm = () => loadCfg();
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 }); else setTimeout(warm, 2500);
  }
})();
